"use strict";

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexMixColor = exports.rgbaMixColors = exports.rgbToHex = exports.hexToRgbaString = exports.hexToRgba = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.every.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Converts HEX color to RGBA format
 * @param colorHex String representing HEX color
 * @param alpha Alpha as number format [0-1]
 * @returns Array with RGB Color components
 */
var hexToRgba = function hexToRgba(colorHex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (!colorHex || !/^#([a-f0-9]{3}|[a-f0-9]{6})$/i.test(colorHex)) return undefined;
  var tempHex = colorHex.replace('#', '');
  var hex = tempHex.length === 3 ? tempHex.replace(/(.)/g, '$1$1') : tempHex;
  return [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16), alpha];
};
/**
 * Converts HEX color to RGBA string
 * @param colorHex String representing HEX color
 * @param alpha Alpha as number format [0-1]
 * @returns String representing RGB Color components
 */


exports.hexToRgba = hexToRgba;

var hexToRgbaString = function hexToRgbaString(colorHex) {
  var _channelArray$toStrin;

  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var channelArray = hexToRgba(colorHex, alpha);
  return channelArray ? "rgba(".concat((_channelArray$toStrin = channelArray.toString) === null || _channelArray$toStrin === void 0 ? void 0 : _channelArray$toStrin.call(channelArray), ")") : undefined;
};
/**
 * Converts RGB color to HEX format
 * @param rgb RGB Color components
 * @returns String representing HEX color
 */


exports.hexToRgbaString = hexToRgbaString;

var rgbToHex = function rgbToHex(rgb) {
  return rgb && rgb.length > 1 && rgb.every(function (bit) {
    return bit >= 0 && bit <= 255;
  }) ? "#".concat(rgb.map(function (bit) {
    var hex = bit.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }).join('')) : '';
};
/**
 * Returns a RGB color based in the blend of two colors. In case of input colors
 * with alpha, resulting color is converted into solid (no alpha).
 * @param base Main color in RGBA format (e.g.: [255, 255, 255, 1])
 * @param added Added color in RGBA format (e.g.: [0, 0, 0, 0.5])
 * @returns Array with the resulting RGB Color components or empty string if conversion fails
 */


exports.rgbToHex = rgbToHex;

var rgbaMixColors = function rgbaMixColors(base, added) {
  if (!base || !base.length || !base.every(function (bit) {
    return bit >= 0 && bit <= 255;
  }) || !added || !added.length || !added.every(function (bit) {
    return bit >= 0 && bit <= 255;
  })) return '';
  var mix = [];
  mix[3] = 1 - (1 - added[3]) * (1 - base[3]); // alpha

  mix[0] = Math.round(added[0] * added[3] / mix[3] + base[0] * base[3] * (1 - added[3]) / mix[3]); // red

  mix[1] = Math.round(added[1] * added[3] / mix[3] + base[1] * base[3] * (1 - added[3]) / mix[3]); // green

  mix[2] = Math.round(added[2] * added[3] / mix[3] + base[2] * base[3] * (1 - added[3]) / mix[3]); // blue

  return _toConsumableArray(mix.slice(0, -1));
};
/**
 * Returns a hex color based in the blend of two colors + alpha
 * @param hexBase Main color in hex format (e.g.: #000000)
 * @param hexAdded Added color in hex format (e.g.: #111111)
 * @param alphaAdded Alpha applied to the added color as number format [0-1]. Default 1.
 * @param alphaBase Alpha applied to the base color as number format [0-1]. Default 1.
 * @returns String with the resulting HEX color
 */


exports.rgbaMixColors = rgbaMixColors;

var hexMixColor = function hexMixColor(hexBase, hexAdded) {
  var alphaAdded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var alphaBase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var rgbaBase = hexToRgba(hexBase, alphaBase);
  var rgbaAdded = hexToRgba(hexAdded, alphaAdded);
  return rgbToHex(rgbaMixColors(rgbaBase, rgbaAdded));
};

exports.hexMixColor = hexMixColor;